import React from 'react';
import { Field } from 'react-final-form';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from '../KeybordDatePicker';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const TextFieldAdapter = ({ input, meta, variant, size, ...rest }) => {
  const { multiline, disabled, style } = rest || {};

  return (
    <TextField
      {...input}
      {...rest}
      onChange={(event) => input.onChange(event.target.value)}
      errortext={meta.touched ? meta.error : ''}
      error={meta.touched && meta.error}
      fullWidth={true}
      multiline={multiline}
      variant={variant || 'outlined'}
      size={size || 'small'}
      style={
        style || !disabled ? { width: '100%', backgroundColor: 'white' } : null
      }
      InputLabelProps={{
        shrink: true,
      }}
      className={'form-control'}
    />
  );
};

const AutocompleteAdapter = ({ input, meta, ...rest }) => {
  const { onChange, value } = input || {};
  const { getOptionLabel, label } = rest || {};
  const selectedOptionHandler = (option, value) => {
    if (option.id && value.id) {
      return option.id === value.id;
    } else if (value.value) {
      return option.value === value.value;
    } else {
      return option === value || null;
    }
  };

  return (
    <Autocomplete
      {...input}
      {...rest}
      value={value ? value : null}
      errortext={meta.touched ? meta.error : ''}
      error={(meta.touched && meta.error) || ''}
      getOptionLabel={(option) =>
        getOptionLabel ? getOptionLabel(option) : option
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          errortext={meta.touched ? meta.error : ''}
          error={meta.touched && meta.error}
        />
      )}
      onChange={(event, selectedItem) => onChange(selectedItem)}
      getOptionSelected={selectedOptionHandler}
    />
  );
};

const DatePickerAdapter = ({ input, meta, ...rest }) => {
  const { onChange } = input || {};

  return (
    <DatePicker
      {...input}
      {...rest}
      errortext={meta.touched ? meta.error : ''}
      error={meta.touched && meta.error}
      handleDateChange={(key, value) => onChange(value)}
    />
  );
};

const RadioButtonsAdapter = ({ input, meta, ...rest }) => {
  const { options, name } = rest || {};
  const renderOptions = (option) => (
    <FormControlLabel
      value={option.value}
      control={<Radio />}
      label={option.label}
    />
  );

  return (
    <RadioGroup row={true} aria-label={name} name={name} {...input}>
      {options.map(renderOptions)}
    </RadioGroup>
  );
};

const field = ({ field, values, translations, disable }) => {
  const {
    type,
    name,
    optionList,
    className,
    getOptionLabel,
    validate,
    condition,
    rows,
    size,
  } = field;

  const label = translations?.[name];

  if (condition && !condition(values)) {
    return null;
  }

  let renderedField = null;

  switch (type) {
    case 'LONG_STRING':
      renderedField = (
        <Field
          name={name}
          component={TextFieldAdapter}
          validate={validate}
          label={label}
          multiline={true}
          rows={rows || 5}
          disabled={disable}
        />
      );
      break;
    case 'text':
    case 'STRING':
      renderedField = (
        <Field
          name={name}
          component={TextFieldAdapter}
          validate={validate}
          label={label}
          disabled={disable}
          size={size}
          required={validate && true}
        />
      );
      break;
    case 'autocomplete':
    case 'COMBO_BOX':
      renderedField = (
        <Field
          name={name}
          component={AutocompleteAdapter}
          options={optionList}
          label={label}
          getOptionLabel={getOptionLabel}
          disabled={disable}
          validate={validate}
          className={className}
        />
      );
      break;
    case 'date':
      renderedField = (
        <Field
          name={name}
          component={DatePickerAdapter}
          label={label}
          disabled={disable}
          validate={validate}
        />
      );
      break;
    case 'radio':
      renderedField = (
        <Field
          name={name}
          component={RadioButtonsAdapter}
          type="radio"
          label={label}
          validate={validate}
          disabled={disable}
          options={optionList}
        />
      );
      break;
    default:
      break;
  }

  return <div className={`field ${name}`}>{renderedField}</div>;
};

export default field;
